export enum GoCardlessRequisitionStatusEnum {
  CREATED = 'CR',
  GIVING_CONSENT = 'GC',
  UNDERGOING_AUTHENTICATION = 'UA',
  REJECTED = 'RJ',
  SELECTING_ACCOUNTS = 'SA',
  GRANTING_ACCESS = 'GA',
  LINKED = 'LN',
  EXPIRED = 'EX',
}
